module.exports = __webpack_public_path__ + "static/media/lock-solid-white.1ea65d78.svg";